const defaultState = {
  deleting: false,
  error: null
}

export default function reducer(state=defaultState, action) {

    switch (action.type) {
      case "DELETE_APPOINTMENT": {
        return {
          ...state,
          deleting: true,
        }
      }
      case "DELETE_APPOINTMENT_FULFILLED": {
        return {
          ...state,
          deleting: false,
        }
      }
      case "DELETE_APPOINTMENT_REJECTED": {
        return {
          ...state,
          error: action.payload,
          deleting: false,
        }
      }
      case "DELETE_APPOINTMENT_CLEAR": {
        return {
          ...state,
          error: null,
          deleting: false,
        }
      }

      default:{
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/js/reducers/deleteAppointmentReducer.js